import React from 'react';
import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../data/blogData';
import SEO from '../components/seo/SEO';
import Breadcrumbs from '../components/navigation/Breadcrumbs';

const BlogList = () => {
    return (
        <div className="container py-5">
            <SEO
                title="ToyTrade Blog - Parenting Tips & Toy Trends in Pakistan"
                description="Read the latest articles about toy trading, parenting tips, and trending collectibles for kids and teenagers in Pakistan."
                canonical="https://toytrade.pk/blog"
            />

            <Breadcrumbs items={[{ label: 'Blog', link: '/blog' }]} />

            <h1 className="text-center mb-5 fw-bold">ToyTrade Blog</h1>

            <div className="row g-4">
                {BLOG_POSTS.map(post => (
                    <div key={post.id} className="col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm border-0">
                            <img
                                src={post.image}
                                className="card-img-top object-fit-cover"
                                style={{ height: '200px' }}
                                alt={post.title}
                                onError={(e) => { e.target.src = '/images/blog/blog_placeholder.jpg' }}
                            />
                            <div className="card-body d-flex flex-column text-start">
                                <div className="d-flex justify-content-between mb-2">
                                    <small className="text-muted">{post.date}</small>
                                    <small className="text-primary">{post.author}</small>
                                </div>
                                <h5 className="card-title fw-bold">{post.title}</h5>
                                <p className="card-text text-muted small mb-4">{post.excerpt}</p>
                                <Link to={`/blog/${post.slug}`} className="btn btn-outline-primary mt-auto">Read More</Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BlogList;
